<div class="container">



    <img src="http://pa1.narvii.com/6884/893d63465f58084348ffb67d55ca80a248439c68r1-291-270_00.gif" class="img-info">
    <div class="content">{{contenu}}</div>

</div>
